import React, { useState } from 'react';
import axios from 'axios';

const LoginPage = ({ setUser }: any) => {
  const [form, setForm] = useState({ user: '', pass: '' });
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
      // const res = await axios.post('http://localhost:5551/login', form);
      // const res = await axios.post('https://attendance.nadezhda.in/login', form);
      const res = await axios.post('/api/login', form);
      // const res = await axios.post('http://192.168.1.11:5000/login', form);
      if (res.data.success) {
        setUser(res.data.user);
      }
    } catch (err) {
      setError('Invalid Username or Password');
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-20 p-8 bg-white rounded-2xl shadow-lg border text-center">
      <h2 className="text-2xl font-black mb-6 text-blue-600">Smart Login</h2>
      <div className="space-y-4">
        <input type="text" placeholder="Username" className="w-full border p-3 rounded-lg outline-none focus:ring-2 focus:ring-blue-400" 
          onChange={e => setForm({...form, user: e.target.value})} />
        <input type="password" placeholder="Password" className="w-full border p-3 rounded-lg outline-none focus:ring-2 focus:ring-blue-400" 
          onChange={e => setForm({...form, pass: e.target.value})} />
        {error && <p className="text-red-500 text-xs font-bold">{error}</p>}
        <button onClick={handleLogin} className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold shadow-md hover:bg-blue-700">Login</button>
      </div>
      <p className="mt-4 text-[10px] text-slate-400">Nadezhda Attendance System v2.0</p>
    </div>
  );
};
export default LoginPage;